import React, { Component } from 'react';
import PanelFilter from './PanelFilter';

const lodash = require('lodash')

class FilterCampagneMarketing extends Component {

  constructor(props) {
    super(props);

    this.state = {
      campagnes: [],
      selected: [],
    }
  }

  componentWillMount() {
    this.loadCampagnes();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.campagnes !== prevProps.campagnes) {
      this.loadCampagnes();
    }
  }

  loadCampagnes() {
    let campagnes = [];

    lodash.forIn(this.props.campagnes, function(value, key){
      campagnes.push({name: key, count: value});
    });

    campagnes = lodash.sortBy(campagnes, ['name']);

    // Une campagne sélectionnée qui n'existe plus dans le nouveau jeu de leads (changement de
    // période, etc.) doit être retirée de la sélection : sinon le filtre reste appliqué sur une
    // valeur qui ne matche plus rien et qui n'est plus affichée pour être décochée.
    const availableNames = campagnes.map((campagne) => campagne.name);
    const selected = this.state.selected.filter((name) => availableNames.indexOf(name) > -1);
    const selectionChanged = selected.length !== this.state.selected.length;

    this.setState({
      campagnes: campagnes,
      selected: selected,
    }, () => {
      if (selectionChanged) {
        this.props.onChange('campagnesMarketing', this.state.selected);
      }
    });
  }

  onChange(event, campagne) {
    let selected = this.state.selected;

    if (event.target.checked) {
      selected.push(campagne)
    }
    else {
      selected = lodash.remove(selected, function(n) {
        return n !== campagne;
      });
    }

    this.setState({selected: selected}, () => {
      this.props.onChange('campagnesMarketing', this.state.selected);
    });
  }

  onChangeAll(value) {
    const selected = [];

    if (value) {
      lodash.forIn(this.props.campagnes, function(value, key){
        selected.push(key);
      });
    }

    this.setState({selected: selected}, () => {
      this.props.onChange('campagnesMarketing', this.state.selected);
    });
  }

  render() {

    const hasCampagnesMarketing = lodash.some(this.state.campagnes, (campagne) => campagne.name);

    if (!hasCampagnesMarketing) {
      return null;
    }

    let campagnes = null;

    if (this.state.campagnes.length) {
      campagnes = this.state.campagnes.map((campagne, i) => {
        return <div className="checkbox" key={i}>
          <input type="checkbox" id={'campagneMarketing-' + i} checked={this.state.selected.indexOf(campagne.name ? campagne.name : '') > -1 ? true : false} onChange={(event) => { this.onChange(event, campagne.name); }} />
          <label className="label-box" htmlFor={'campagneMarketing-' + i}>
            {campagne.name ? campagne.name : <span className="text-muted" style={{ fontStyle: 'italic' }}>Aucune</span>}
            &nbsp;<span className="count">({campagne.count})</span>
          </label>

          <div className='clearfix' />
        </div>;
      });
    }

    return (
      <PanelFilter title="Par campagne eDataVoice" allSelected={this.state.selected.length === this.state.campagnes.length ? true : false} onChangeAll={this.onChangeAll.bind(this)}>
        {campagnes}
      </PanelFilter>
    );
  }
}

export default FilterCampagneMarketing;
